import React from 'react';
import { Route, IndexRoute, IndexRedirect, Redirect } from 'react-router';
import customersRoutes from '../main/customers/routes';
import barbersRoutes from '../main/barbers/routes';
import SettingsRoutes from '../main/settings/routes';
import EngagementRoutes from '../engagement/routes';
import { CampaignBuilderRoutes } from '../../modules/shared/engage/campaign-builder/routes';
import CombinedView from '../main/appointments/views/combined/combinedView';
import AppointmentList from '../main/appointments/views/list/appointmentsList';
import BarberApp from './barberApp';
import ReportsRoutes from '../main/reports/routes';
import EditServiceProvider from '../main/services/containers/editServiceProvider';
import ListServicesProvider from '../main/services/containers/listServicesProvider';
import CancelAppointment from '../main/appointments/appointmentForm/cancelAppointment';
import { BarberProductRoutes } from '../products/routes';
import RegisterRoutes from '../register/routes';
import ServiceCategoriesRoutes from '../main/services/categories/routes';
import SideBySideView from '../main/appointments/views/sideBySide/containers/SideBySideView';
import * as hooks from '../auth/routerHooks';
import { containerApp } from '../../main';
import LoansRoutes from '../loans/routes';
import { FS_FEATURES } from '../../modules/infra/observability/fullstory';

export default store => (
  <Route path="/barber" component={BarberApp} onEnter={hooks.requireBarber(store)}>
    <IndexRedirect
      to="appointments"
      display-if={!containerApp.isActive()}
    />
    <Route
      path="appointments"
      name="appointments"
      onLeave={hooks.resetAppointmentsDate(store)}
      onEnter={hooks.initFullstoryFeature(FS_FEATURES.CALENDAR)}
      display-if={!containerApp.isActive()}
    >
      <IndexRoute component={SideBySideView} />
      <Route path="list" component={AppointmentList} />
      <Route path="week" component={() => (<CombinedView currentView="agendaWeek" />)} />
      <Route path=":cancel" name="appointment.cancel" component={CancelAppointment} />
    </Route>

    {customersRoutes.BarberRoutes(store)}
    {barbersRoutes.BarberRoutes(store)}

    <Route
      path="services"
      name="services"
      onEnter={hooks.requireServiceViewPermission(store)}
    >
      <IndexRoute component={ListServicesProvider} />
      <Route
        path="categories"
        onEnter={hooks.requireServiceCategoriesPermission(store)}
      >
        {ServiceCategoriesRoutes()}
      </Route>
      <Route
        path="add"
        name="services.add"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceAddPermission(store)}
      />
      <Route
        path=":serviceId"
        name="services.details"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceModifyPermission(store)}
      />
      <Route
        path=":serviceId/assign"
        name="services.assign"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceModifyPermission(store)}
      />
    </Route>
    {ReportsRoutes.BarberRoutes(store)}
    {SettingsRoutes.BarberRoutes(store)}
    {BarberProductRoutes(store)}
    {RegisterRoutes(store)}
    {EngagementRoutes(store)}
    {CampaignBuilderRoutes(store)}
    {LoansRoutes(store)}

    {/* routes for deeplinking to mobile app, that don't exist in web  */}
    <Redirect from="self-onboarding" to="/" />
    <Redirect from="ttp-education" to="/" />
  </Route>
);
